import { ChangeEvent, FC, useEffect, useState } from 'react';
import { Close, Input, InputWrapper } from './styles';
import { CloseIconButton } from '../buttons/iconButtons/closeButton';

interface InputSearchProps {
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	clear?: boolean;
	hide?: boolean;
}

export const InputSearch: FC<InputSearchProps> = ({
	onChange,
	clear = false,
	hide = false,
}) => {
	const [inputValue, setInputValue] = useState('');

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(event.target.value);
		onChange(event);
	};

	const handleClear = () => {
		setInputValue('');
		onChange({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
	};

	useEffect(() => {
		if (clear) {
			setInputValue('');
		}
	}, [clear]);

	return (
		<InputWrapper $hide={hide}>
			<Input
				role="input-search"
				value={inputValue}
				onChange={handleChange}
				autoComplete="off"
				$hide={hide}
			/>
			{inputValue && (
				<Close>
					<CloseIconButton onClick={handleClear} />
				</Close>
			)}
		</InputWrapper>
	);
};
